var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"A24arle0_gqZLSP72Kr70"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["akiverse-worldmanager-frontend-production"]={id:"A24arle0_gqZLSP72Kr70"};
      